import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/demos/manager-study-clinician-invite-plan")({
    beforeLoad: () => {
        throw redirect({ to: "/design/features/manager-study-clinician-invite-plan", replace: true });
    },
});
